import { Controller } from "@hotwired/stimulus"

// Owns the recurring-bound UI: toggles visibility of the cycle-count input
// based on the selected radio, and keeps the cycle-count suffix label in sync
// with the selected recurring pattern.
//
// Markup expects two radios with name="appointment[bound_type]" and values
// "open", "cycles"; target cyclesFields is the input shown conditionally;
// cycleLabel is the suffix span ("weeks" / "cycles" / "months"). The pattern
// radios live outside this controller — we listen at the document level so
// this controller stays self-contained.
const PATTERN_LABELS = {
  weekly: "weeks",
  biweekly: "cycles",
  monthly: "months"
}

export default class extends Controller {
  static targets = ["cyclesFields", "cycleLabel", "radio"]

  connect() {
    this.radioTargets.forEach((radio) => {
      radio.addEventListener("change", () => this.refresh())
    })
    this.boundPatternRefresh = this.refreshLabel.bind(this)
    document.addEventListener("change", this.boundPatternRefresh)
    this.refresh()
  }

  disconnect() {
    document.removeEventListener("change", this.boundPatternRefresh)
  }

  refresh() {
    const checked = this.radioTargets.find((r) => r.checked)?.value
    if (checked === "cycles") {
      this.cyclesFieldsTarget.classList.remove("hidden")
    } else {
      this.cyclesFieldsTarget.classList.add("hidden")
    }
    this.refreshLabel()
  }

  refreshLabel() {
    if (!this.hasCycleLabelTarget) return
    const pattern = document.querySelector('input[name="appointment[recurring_pattern]"]:checked')?.value
    this.cycleLabelTarget.textContent = PATTERN_LABELS[pattern] || "cycles"
  }
}
